import { Pool } from "../../utils/Pool";
const className = "ClipRectCmd";
export class ClipRectCmd {
    static create(x, y, width, height) {
        var cmd = Pool.getItemByClass(className, ClipRectCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.width = width;
        cmd.height = height;
        return cmd;
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        runner.clipRect(this.x + gx, this.y + gy, this.width, this.height);
    }
    get cmdID() {
        return ClipRectCmd.ID;
    }
}
ClipRectCmd.ID = className;
